<template>
  <div class="mp-pager" v-if="maxPage > 1">
    <button class="btn btn-primary bg-c-p float-left me-2" v-if="page > 1" v-on:click="prevPage"><i class="fal fa-angle-left"></i></button>
    <button class="btn btn-primary bg-c-p float-right" v-if="page < maxPage" v-on:click="nextPage"><i class="fal fa-angle-right"></i></button>
  </div>
</template>

<script>
export default {
  name: "MdPaperPager",
  props: {
    page: Number,
    maxPage: Number
  },
  methods: {
    changePage: function (number) {
      var self = this;
      if (number < 1) {
        number = 1;
      }
      if (number > self.maxPage) {
        number = self.maxPage;
      }
      self.$emit("paging", number);
    },
    prevPage: function (e) {
      var self = this;
      e.preventDefault();
      self.changePage(self.page - 1);
    },
    nextPage: function (e) {
      var self = this;
      e.preventDefault();
      self.changePage(self.page + 1);
    }
  }
}
</script>